module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-container"
  }, [_vm._t("default"), _vm._v(" "), _c('input', {
    attrs: {
      "multiple": "",
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.upload($event.target.files)
      }
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cf2be07"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/UploadFirebase.vue
// module id = 2512
// module chunks = 1